export const mockServer = 'https://www.dianzhantech.com/'
export const productionUrl = 'https://www.dianzhantech.com/'
